import { AxiosError } from 'axios'
import { IFormFilterFormData } from 'schema/authentication/home/dashboard/form-filter'
import api from './api'

export const getDashboardCount = async (filter: IFormFilterFormData) => {
  try {
    const { data } = await api.post('/conducco-cdp-employees/dashboard-count', {
      startDate: filter?.startDate || '',
      endDate: filter?.endDate || '',
      organization: filter?.organization,
    })

    return data.data
  } catch (e) {
    const error = e as AxiosError

    console.log((error.response?.data as any).message)
  }
}

export const getDashboardData = async (filter: IFormFilterFormData) => {
  try {
    const { data } = await api.post('/conducco-cdp-employees/dashboard', {
      startDate: filter?.startDate || '',
      endDate: filter?.endDate || '',
      organization: filter?.organization,
    })

    return data
  } catch (e) {
    const error = e as AxiosError
    console.log((error.response?.data as any).message)
  }
}

export const getOrganizationOptions = async () => {
  try {
    const { data } = await api.post('/organizations/list', {
      columnOrder: [],
      page: 0,
      rowsPerPage: 100,
      search: '',
      status: '',
      organizationId: '',
    })

    const result = data.data.map((item: any) => ({
      id: item.id,
      name: item?.corporateName,
    }))

    return result
  } catch (e) {
    const error = e as AxiosError
    console.log((error.response?.data as any).message)
  }
}

export const getProjectExecutions = async () => {
  try {
    const { data } = await api.post('/project-executions/list', {
      columnOrder: [],
      page: 0,
      rowsPerPage: 100,
      search: '',
    })

    return data
  } catch (e) {
    const error = e as AxiosError
    console.log((error.response?.data as any).message)
  }
}

export const getCatalogs = async (filter: IFormFilterFormData) => {
  try {
    const { data } = await api.post('/conducco-cdp-employees/catalogs', {
      startDate: filter?.startDate || '',
      endDate: filter?.endDate || '',
      organization: filter?.organization,
    })

    return data
  } catch (e) {
    const error = e as AxiosError
    console.log((error.response?.data as any).message)
  }
}
